import { useState } from "react";

import { useForm, Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import { handleCreateErrors } from "../../../components/utils/errors"

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useGetUnlimitedListOf from "../../../hooks/useGetUnlimitedListOf";


const Create = ({ handleOpen, open }) => {
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();

  const table = "Promotion_Components";

  const [selectedpromotion_id, setSelectedpromotion_id] = useState(null);
  const [selectedinput_type_id, setSelectedinput_type_id] = useState(null);
  const promotionsTemp = useGetUnlimitedListOf("Promotions", "", "list");
  const promotionsData = promotionsTemp.listElements;

  const input_typesTemp = useGetUnlimitedListOf("Input_Types", "", "list");
  const input_typesData = input_typesTemp.listElements;

  const columns = ["id", "promotion_id", "input_type_id", "title", "options", "obligatory", "order"];

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const create = async (formData) => {
if (!formData.promotion_id?.trim() || formData.input_type_id === null || !formData.title?.trim() || !formData.options?.trim() || formData.order === null) {
    window.alert("promotion_id, input_type_id, title, options, order non possono essere vuoti!");
    return;
  }


	 const errors = {}
	 const apiCall = `/${table}/create`
    try {
      const response = await axiosPrivate.post(apiCall, formData);
      if (!response) throw new Error("Errore nella creazione");

      window.alert("Creazione avvenuta con successo")

    } catch (error) {
    errors.call = apiCall;
    errors.callData = formData;
    errors.error = error;
    errors.forceReload = false;

    handleCreateErrors(errors, true)

    }
  };

  return (
    <>
      <Modal open={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
          }}
          alignItems={"center"}
        >
          <Box display={"flex"} justifyContent={"space-between"} sx={{ mb: 2 }}>
            <Typography
              id="keep-mounted-modal-title"
              variant="h6"
              component="h2"
            >
              Crea un nuovo elemento per la tabella {table}
            </Typography>
            <Button
              color="error"
              onClick={() => handleOpen(false, "create")}
              sx={{
                maxWidth: "30px",
                maxHeight: "30px",
                minWidth: "30px",
                minHeight: "30px",
              }}
            >
              <CloseIcon />
            </Button>
          </Box>
          <Box
            display={"flex"}
            justifyContent={"center"}
            sx={{ width: "100%" }}
          >
            {/* Autocomplete per il campo promotion_id */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={promotionsData}
              getOptionLabel={(option) => option.id}
              value={
                selectedpromotion_id
                  ? promotionsData.find((promotion) => promotion.id === selectedpromotion_id)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedpromotion_id(newValue.id);
                  setValue("promotion_id", newValue.id);
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select promotion_id"
                  placeholder="promotion_id"
                  error={!!errors.promotion_id}
                  helperText={
                    errors.promotion_id ? "Il campo promotion_id è obbligatorio" : ""
                  }
                />
              )}
            />
          </Box>
          <Box
            display={"flex"}
            justifyContent={"center"}
            sx={{ width: "100%" }}
          >
            {/* Autocomplete per il campo input_type_id */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={input_typesData}
              getOptionLabel={(option) => option.id}
              value={
                selectedinput_type_id
                  ? input_typesData.find((promotion) => promotion.id === selectedinput_type_id)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedinput_type_id(newValue.id);
                  setValue("input_type_id", newValue.id);
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select input_type_id"
                  placeholder="input_type_id"
                  error={!!errors.input_type_id}
                  helperText={
                    errors.input_type_id ? "Il campo input_type_id è obbligatorio" : ""
                  }
                />
              )}
            />
          </Box>

          {/* Altri campi */}
          {columns
            .filter((column) => column !=="id" && column !== "promotion_id" && column !== "input_type_id" && column !== "obligatory")
            .map((column, index) => (
              <TextField
                key={index}
                placeholder={column}
                sx={{ width: "50%", m: 1 }}
                {...register(column)}
              />
            ))}

{/* switch per campo obligatory */}
<Controller
      name="obligatory"
      control={control}
      defaultValue={false}
      render={({ field }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Typography sx={{ mr: 2 }}>obligatory:</Typography>
          <Switch color="primary" {...field} checked={field.value} />
        </Box>
      )}
    />


          <Button onClick={handleSubmit(create)}>CREA ENTRY</Button>
        </Box>
      </Modal>
    </>
  );
};

export default Create;